import { Capacitor } from '@capacitor/core'
import { useAxios, useSubjectMember } from '@healthblocks-io/core'
import { useCallback, useState } from 'react'

import type { ActorMember } from '@healthblocks-io/core/types'
import type { ICSToken } from '../types/ics-token.type'

function useScheduleSync() {
  const axios = useAxios()
  const member = useSubjectMember()

  const [isLoading, setIsLoading] = useState(false)
  const [url, setUrl] = useState<string>()

  const getICS = useCallback(
    (member: ActorMember) => {
      return axios.get<ICSToken>(`/member/${member.id}/calendar`)
    },
    [axios],
  )

  const execute = useCallback(async () => {
    setIsLoading(true)
    if (member) {
      try {
        const ics = await getICS(member)
        setUrl(Capacitor.getPlatform() === 'android' ? ics.data.url : ics.data.webcal)
      } catch (error) {
        console.error(error)
      }
    }
    setIsLoading(false)
  }, [member, getICS])

  return {
    execute,
    isLoading,
    value: url,
  }
}

export { useScheduleSync }
